import { Dialog, DialogContent, DialogTitle, Divider, Grid, Stack } from '@mui/material'
import SelectInput from '@/components/ui/inputs/SelectInput'
import { ExaminationTypes } from '@/core/classes/MedconnectDevicesAPI'
import { useTranslation } from 'react-i18next'

const ExamTypes: ExaminationTypes[] = [ExaminationTypes.RestingECG, ExaminationTypes.Spirometry, ExaminationTypes.StressECG]

type ExamSelectorDialogProps = {
  open: boolean
  onClose: () => void
  onExamSelected: (examType: ExaminationTypes) => void
}

export function ExamSelectorDialog(props: ExamSelectorDialogProps) {
  const { open, onClose, onExamSelected } = props
  const { t } = useTranslation()

  const handleClose = () => {
    onExamSelected(ExamTypes[0] as ExaminationTypes)
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('component.ui.MedconnectDevice.examSelector.title')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Divider />
          <Grid container spacing={2}>
            <SelectInput
              defaultValue={t(`component.ui.MedconnectDevice.examSelector.${ExamTypes[0]}`)}
              label={t('component.ui.MedconnectDevice.examSelector.examType')}
              options={ExamTypes.map((e) => {
                return {
                  label: t(`component.ui.MedconnectDevice.examSelector.type.${e}`),
                  value: e,
                }
              })}
              required
              sx={{ width: '100%' }}
              onChange={(e) => onExamSelected(e.target.value as ExaminationTypes)}
            />
          </Grid>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
